import styled from 'styled-components';
import { arrayOf, shape, string, bool, func } from 'prop-types';

import StyledButton from '../../components/shared/StyledButton';
import Card from './Card';
import CardPlaceholder from './CardPlaceholder';
import StyledText from '../../components/shared/StyledText';
import ErrorBoundary from '../shared/ErrorBoundary';
import {
  WHITE_COLOR,
  MAIN_COLOR,
  MEDIUM_TEXT,
  DESKTOP_SIZE,
} from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  padding: 54px;

  @media (max-width: ${DESKTOP_SIZE}) {
    text-align: center;
    padding: 10px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-gap: 80px 40px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));

  @media (min-width: ${DESKTOP_SIZE}) {
    grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  }
`;

const renderGames = (games, isCacheDirty, t) => {
  if (games.length === 0 && !isCacheDirty) {
    return t('COMPONENTS_GAMES_CARD_LOADING');
  } else if (games.length === 0) {
    return t('COMPONENTS_GAMES_CARD_NO_RESULT');
  }

  return games.map((game, key) => (
    <ErrorBoundary placeholder={CardPlaceholder} key={key}>
      <Card game={game} />
    </ErrorBoundary>
  ));
};

const GameCards = ({
  games,
  isCacheDirty,
  showLoadMoreButton,
  updateGames,
  sectionTitle,
  t,
}) => (
  <Container>
    <StyledText size={MEDIUM_TEXT} isBold margin="0 0 20px 0">
      {sectionTitle
        ? `${t('COMPONENTS_GAMES_CARD_SEARCH_RESULT')}  "${sectionTitle}"`
        : `${t('COMPONENTS_GAMES_CARD_SECTION_TITLE')}`}
    </StyledText>
    <Grid>{renderGames(games, isCacheDirty, t)}</Grid>
    {showLoadMoreButton && (
      <StyledButton
        background={MAIN_COLOR}
        onClick={() => updateGames(false)}
        margin="50px auto 20px auto"
      >
        <StyledText size={MEDIUM_TEXT} color={WHITE_COLOR} isBold>
          {t('COMPONENTS_GAMES_CARD_BUTTON_SHOW_MORE')}
        </StyledText>
      </StyledButton>
    )}
  </Container>
);

GameCards.propTypes = {
  sectionTitle: string,
  showLoadMoreButton: bool.isRequired,
  isCacheDirty: bool.isRequired,
  updateGames: func.isRequired,
  games: arrayOf(
    shape({
      id: string.isRequired,
      min_age: string,
      min_players: string,
      short_descr: string.isRequired,
      title: string.isRequired,
    })
  ).isRequired,
};

export default withI18next()(GameCards);



// WEBPACK FOOTER //
// components/GameCards/index.js